import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux';

import { cadastrarUser } from '../../actions'
import { toast } from 'react-toastify';
import InputMask from "react-input-mask";

const INITIAL_FORM = {
    email: '',
    senha: '',
    cnpj: '',
    nome: ''
} 

class ModalFormUser extends Component {
    constructor(props){
        super(props)

        this.state = {
            modalIsOpen: true,
            form: {
                email: '',
                senha: '',
                cnpj: '',
                nome: '',
                nivel_acesso: '0'
            }
        }

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onSubmitForm = this.onSubmitForm.bind(this);
    }

    openModal() {
        //this.setState({modalIsOpen: true});
        this.props.openModal()
    }

    closeModal() {
        //console.log(this.props)
        this.props.closeModal()
        //this.setState({modalIsOpen: false});
    }

    handleInputChange(event){
        var form = this.state.form
        const { name, value } = event.target
        form[name] = value
        this.setState({ form })
    }

    onSubmitForm(event){
        event.preventDefault()
        var form = this.state.form
        for( let i in form )
            if((form[i]).trim() == '' )
                return alert('Preencha todos os campos! campo '+i)
 
        this.props.cadastrarUser(form, async res => {
            if(res) {
                await this.setState({ form: {...INITIAL_FORM} })
                try{
                    await Array.from( document.querySelectorAll('form#cadastroUser input') ).map( input => input.value = '')
                    
                    if(document.querySelector('#modalFormUser .close'))
                        document.querySelector('#modalFormUser .close').click()

                } catch (error) {
                    console.log('ERROR',error)
                }
                toast.success('Usuário cadastrado com sucesso!')
            }
                
        })
    }

    getLogo(){
        const { logo } = this.props.auth.empresa
        var logoEmpresa =  '/assets/imagem/logo.png'
        if(logo)
            logoEmpresa = 'data:image/png;base64,'+logo

        return logoEmpresa
    }
    
    render(){
        const { loading_auth, error_cadastro, msg_cadastroUser } = this.props.auth
        return(
            <div className="modal fade" id="modalFormUser" tabIndex="-1" role="dialog" aria-labelledby="modalAddUser"
            aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                    <form id="cadastroUser" className="form-signin" onSubmit={this.onSubmitForm}>
                        
                        <button style={{ position:'absolute', right: 30 }} type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>                        

                        {/* <img className="mb-4" src={this.getLogo()} alt="" width="100" height="100" /> */}
                        <h1 className="h3 mb-3 font-weight-normal">Cadastrar Usuário</h1>
                        
                        <div className="form-group">
                            <label  className="sr-only">CPF/CNPJ</label>
                            {/* <input maxLength="14" name="cnpj" type="text"  className="form-control" placeholder="CPF/CNPJ" required onChange={this.handleInputChange} /> */}
                            <InputMask name="cnpj" type="numeric"  className="form-control" placeholder="CPF/CNPJ" required 
                            onChange={this.handleInputChange} mask="999.999.999-99"/>
                        </div>
                        
                        <div className="form-group">
                            <label  className="sr-only">Nome/Razão Social</label>
                            <input name="nome" type="text"  className="form-control" placeholder="Nome/Razão Social" required onChange={this.handleInputChange} />
                        </div>
                        
                        <div className="form-group">
                            <label  className="sr-only">E-mail</label>
                            <input name="email" type="email" id="inputEmail" className="form-control" placeholder="E-mail" required  onChange={this.handleInputChange} />
                        </div>

                        <div className="form-group">
                            <label  className="sr-only">Senha</label>
                            <input name="senha" type="password" id="inputPassword" className="form-control" placeholder="Senha" required onChange={this.handleInputChange} />
                        </div>

                        <div className="form-group">
                            <label>Nível de acesso</label>
                            <select name="nivel_acesso" className="form-control" value={this.state.form.nivel_acesso} onChange={this.handleInputChange}>
                                <option value="0">COMUM</option>
                                <option value="1">ADMINISTRATIVO</option>
                            </select>
                        </div>
            
                        <button className="btn btn-lg btn-primary btn-block" type="submit" role="button" disabled={loading_auth}>
                            {loading_auth ?<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>:null}
                            {loading_auth ? '   Aguarde...' : 'Entrar'}
                        </button>

                    </form>

                        {msg_cadastroUser != ''
                            ?<div className={`alert alert-${error_cadastro ? 'danger' : 'success'}`} role="alert" style={{marginTop:'1%'}}>
                                {msg_cadastroUser}
                            </div>
                            :null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ auth }) => {
    return {
        auth
    }
}

export default connect(mapStateToProps, {
    cadastrarUser
})(ModalFormUser);

const customStyles = {
    main: {
        paddingLeft: '2%',
        paddingRight: '2%'
    },
    modal:{
        width:'50%',
        // height: '50%',
        left:'35%',
        top: '80px',
    }
}